import { TableValueTypeEnum } from '../../enums';
import { CustomMedia } from '../custom-media.model';
import { Wrapper } from '../wrapper.model';

export interface TableValueInterface extends Wrapper {
  tableValueType?: TableValueTypeEnum;
  label?: string;
  media?: CustomMedia;
  url?: string;
  checked?: string;
  tag?: string;
  tagTheme?: TableThemeEnum;
  isStar?: string;
  maxRating?: number;
  rating?: number;
  indexFollow?: boolean;
}

export interface TableColumnInterface extends Wrapper {
  values?: string;
  valuesObjects?: TableValueInterface[];
}

export interface TableComponentInterface extends Wrapper {
  columns?: string;
  doubleEntries?: string;
  columnsObjects?: TableColumnInterface[];
  maxLine?: number;
  maxColumn?: number;
  showSize?: number;
  titleLevel?: string;
  title?: string;
}

export enum TableThemeEnum {
  BRAND = 'BRAND',
  EXTRA = 'EXTRA',
  PROMO1 = 'PROMO1',
  PROMO2 = 'PROMO2',
  STARS = 'STARS',
  LIGHT = 'LIGHT',
  DARK = 'DARK'
}
